import RequestAbstract from "../abstract";

export default class CryptoPayments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/crypto-payments';
    }

    async assign(data) {
        return await this.post(`${this.link}/assign-terminal`, data);
    }
}
